/**
 * Result of the last Prepare write for an open auto order.
 *
 * The order grid keeps the entered quantities and the open order until the
 * Firestore write reports back, so it needs to know which order the result
 * belongs to and whether it succeeded.
 */
export interface IAutoOrderPrepareOutcome extends Object {
  orderId: string;
  succeeded: boolean;
}
